module.exports = __webpack_public_path__ + "static/media/cardQsusp.95f417a0.svg";